//讲师邀请确认
import React from 'react';
import '../../assets/css/common/teacher/index.css';
import {localParam} from '../../assets/js/utils/util.js';
import {request} from '../../assets/js/libs/request.js';
import config from '../../assets/js/conf/config.js';
import { Toast } from 'antd-mobile';


export default class teacherIndex extends React.Component {
	constructor(props){
		super(props)
		this.state = {
			UrlDate: localStorage['UrlDate'] !== undefined?JSON.parse(localStorage['UrlDate']):'',
		};
	}
	componentDidMount(props) {
		
	}
	componentWillUnmount(){
    	//界面离开的时候
		this.setState = (state, callback)=>{
			return;
		}
	}
	btnClick2(){
		this.props.history.replace('/video/detail?olId='+this.state.UrlDate.merchandiseId);
	}
	
	render() {
		return(
			<div className={'teacher'}>
				<div className={'teacher-success'}>
					<div>
						<div className={'icon'}>
							<img src={require('../../assets/images/teacher/jsImg3.png')} />
						</div>
						<div className={'text'}>您已接受本次邀请<br/>成为特邀讲师</div>
					</div>
					<div className='XF'>
						<button onClick={this.btnClick2.bind(this)}>进入直播间</button>
					</div>
					{
						// <div className='foot'>
						// 	<div>	
						// 		<p>微信网页:</p>
						// 		<img src={require('../../assets/images/pttStudent.png')} />
						// 	</div>
						// 	<div>
						// 		<p>微信网页:</p>
						// 		<img src={require('../../assets/images/pttStudent.png')} />
						// 	</div>
						// </div>
					}
					
				</div>
		    </div>
		);
	}
}